module.exports = __webpack_public_path__ + "img/IMG_2516-2.30f0b7a8.jpg";